module.exports = __webpack_public_path__ + "img/83400.391d3ef9.jpg";